import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import routes from "../api/routes";
import { messageShow } from "../../common/api/actions";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import EmptyMessage from "../../common/EmptyMessage";
import { Paper, Button, Toolbar, Typography, Tooltip, IconButton, Box, Grid } from "@mui/material";
import { Table, TableBody, TableCell, TableHead, TableRow, Pagination } from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import ApiIcon from "@mui/icons-material/Api";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { getKnowledgeCategory, getIntentsByKnowledgeCategory, getIntents } from '../api/actions/query';
import { removeKnowledge, removeIntent, trainIntents } from "../api/actions/mutation";
import { checkPermission } from '../../common/Sidebar/checkPermission';
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      KnowledgeCategory: [],
      Intents: [],
      isLoading: true,
      activeCategoryId: null,
      currentPage: 1,
      rowsPerPage: 5,
      permissions: {canEdit: false, canView: false, canCreate: false, canDelete: false},
      isSuperAdmin: false
    };
  }

  componentDidMount() {
    this.fetchKnowledgeCatgeory().then(() => {
      const { KnowledgeCategory } = this.state;
      if (KnowledgeCategory.length > 0) {
        const firstCategoryId = KnowledgeCategory[0]._id;
        this.fetchIntentsByCategory(firstCategoryId);
        this.setState({ activeCategoryId: firstCategoryId });
      }
    });
    this.fetchPermissions();
    this.checkSuperAdmin();
  }

  checkSuperAdmin = () => {
    const userRole = localStorage.getItem('user');
    if (userRole) {
      const userData = JSON.parse(userRole);
      const isSuperAdmin = userData?.roleDetails?.name === "Super Admin";
      this.setState({ isSuperAdmin });
    }
  }

  fetchPermissions= async () => {
    const permissions = await checkPermission("engagement","intentManager");
    this.setState({permissions})
  }

  fetchKnowledgeCatgeory = async () => {
    const { getKnowledgeCategory, getIntents } = this.props;
    this.setState({ isLoading: true });
    try {
      const [catResponse, intentResponse] = await Promise.all([
        getKnowledgeCategory(),
        getIntents()
      ]);

      if (catResponse.data.success && catResponse.data.data) {
        let categories = catResponse.data.data;
        if (intentResponse.data.success && intentResponse.data.data) {
          const intents = intentResponse.data.data;
          categories = categories.map(cat => ({
            ...cat,
            intentsCount: intents.filter(i => i.knowledgeCategoryId === cat._id).length
          }));
        }
        this.setState({
          KnowledgeCategory: categories,
        });
      }
    } catch (error) {
      console.error('Error fetching Knowledge Categories:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  fetchIntentsByCategory = async (knowledgeCategoryId) => {
    const { getIntentsByKnowledgeCategory } = this.props;
    this.setState({ isLoading: true });

    try {
      const response = await getIntentsByKnowledgeCategory({ knowledgeCategoryId });

      if (response.data.success && response.data.data) {
        this.setState({
          Intents: response.data.data,
          activeCategoryId: knowledgeCategoryId
        });
      }
    } catch (error) {
      console.error('Error fetching Intents by Knowledge Category:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  };


  handleDelete = async (intentId, knowledgeCategoryId) => {
    const { messageShow, removeIntent } = this.props;

    const confirmDelete = window.confirm(
      `Are you sure you want to delete this Intent?`
    );

    if (!confirmDelete) {
      return;
    }

    try {
      const response = await removeIntent({ intentId });
      if (response.data.success) {
        messageShow(response.data.message);
        this.fetchIntentsByCategory(knowledgeCategoryId);
      }
    } catch (error) {
      console.error("Error deleting Intent:", error);
      messageShow("Error deleting Intent")
    }
  };

  handleTrainModel = async () => {
    const { trainIntents, messageShow } = this.props;

    try {
      const response = await trainIntents();
      if (response.data.success) {
        messageShow(response.data.message);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error("Error training model:", error);
      messageShow("Error training model");
    }
  };

  handlePageChange = (event, newPage) => {
    this.setState({ currentPage: newPage });
  };

  handleDeleteCategory = async (knowledgeCategoryId) => {
    const { messageShow, removeKnowledge } = this.props;

    const confirmDelete = window.confirm(
      `Are you sure you want to delete this knowledge category?`
    );

    if (!confirmDelete) {
      return;
    }

    try {
      const response = await removeKnowledge({ knowledgeCategoryId });
      if (response.data.success) {
        messageShow(response.data.message);
        this.fetchKnowledgeCatgeory();
      }
    } catch (error) {
      console.error("Error deleting Knowledge category:", error);
      messageShow("Error deleting Knowledge category")
    }
  };

  // Render Helper Section
  renderHelper = () => {
    return (
      <Box sx={{ p: 2, pt: 0 }}>
        <Box 
          sx={{ 
            backgroundColor: '#F8F9FE', 
            borderRadius: '8px', 
            border: '1px solid #E9ECEF',
            p: 3
          }}
        >
          <Box display="flex" alignItems="center" mb={2} sx={{ color: '#5E72E4' }}>
            <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
              INTENT MANAGER QUICK TIPS
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Knowledge Categories:</span> Group your intents by categories. Create a category first before adding intents to keep your bot organized.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Intents & Utterances:</span> Define intents for what users might ask. Add various utterances (ways of asking) to improve recognition accuracy.
                </Typography>
              </Box>
            </Grid>

            {this.state.isSuperAdmin && (
              <Grid item xs={12} md={4}>
                <Box display="flex" alignItems="flex-start">
                  <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                  <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                    <span style={{ fontWeight: 600, color: '#32325D' }}>Train Model:</span> After adding or modifying intents, click "Train Model" to update the Smart's understanding of the new data.
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props;
    const { isLoading, Intents, KnowledgeCategory, activeCategoryId, currentPage, rowsPerPage, permissions, isSuperAdmin } = this.state;

    const indexOfLastIntent = currentPage * rowsPerPage;
    const indexOfFirstIntent = indexOfLastIntent - rowsPerPage;
    const currentIntents = Intents.slice(indexOfFirstIntent, indexOfLastIntent);

    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Manage Intents
          </Typography>
          {KnowledgeCategory.length > 0 && Intents.length > 0 && isSuperAdmin && (
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleTrainModel}
            >
              Train Model
            </Button>
          )}
          <Link to={{
            pathname : routes.botSettings.path,
            state: {permissions}
          }}>
            <Tooltip title="Settings" arrow>
              <IconButton 
                sx={{ color: '#0d3559' }}
              >
                <SettingsIcon />
              </IconButton>
            </Tooltip>
          </Link>
        </Toolbar>

        {isLoading ? (
          <BrandedLoading />
        ) : KnowledgeCategory.length === 0 ? (
          <div style={{ width: "100%", padding: "20px" }}>
            <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <EmptyMessage message={"No Knowledge Category added yet."} />
              <Link to={routes.knowledgeCreate.path}>
                <Tooltip title="Create Knowledge" arrow>
                  <Button size='big' color="primary" startIcon={<AddIcon />} style={{ marginLeft: 'auto' }}></Button>
                </Tooltip>
              </Link>
            </Paper>
          </div>
        ) : (
          <div style={{ display: 'flex', height: '100%', backgroundColor: '#FDFDFD' }}>
            <div className={classes.sidebarCard}>
              <div className={classes.sidebarHeader}>
                <Typography variant="h6" style={{ fontSize: '16px', fontWeight: 500 }}>Knowledge Category</Typography>
                <Tooltip title="Add Category" arrow>
                  <IconButton color="primary" size="small" component={Link} to={routes.knowledgeCreate.path} disabled={!permissions.canCreate}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </div>
              <div style={{ paddingBottom: '10px' }}>
                {KnowledgeCategory.map(category => (
                  <div
                    key={category._id}
                    className={`${classes.categoryItem} ${activeCategoryId === category._id ? classes.activeCategory : ''}`}
                    onClick={() => this.fetchIntentsByCategory(category._id)}
                  >
                    <div>
                      <Typography className="category-name" style={{ fontSize: '15px' }}>{category.name}</Typography>
                      <Typography className={classes.categorySubtext}>{category.intentsCount || 0} items</Typography>
                    </div>
                    <div className={`${classes.actionIcons} action-icons`}>
                      <Tooltip title="Edit Category" arrow>
                        <IconButton
                          size="small"
                          color="primary"
                          component={Link}
                          to={{
                            pathname: routes.knowledgeCreate.path,
                            state: { category }
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <EditIcon style={{ fontSize: '18px' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete Category" arrow>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            if(permissions.canDelete) this.handleDeleteCategory(category._id);
                          }}
                          disabled={!permissions.canDelete}
                        >
                          <DeleteIcon style={{ fontSize: '18px' }} />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column', padding: '20px 20px 20px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
                {permissions.canCreate && (
                  <Link
                    to={{
                      pathname: routes.intentCreate.path,
                      state: { knowledgeCategoryId: this.state.activeCategoryId }
                    }}
                    className={classes.addIntentButton}
                  >
                    <AddIcon style={{ fontSize: '20px' }} />
                    ADD INTENT
                  </Link>
                )}
              </div>
              <SectionPaper style={{ padding: 0, overflow: 'hidden', borderRadius: '8px', border: '1px solid #E0E0E0' }}>
                {isLoading ? (
                  <BrandedLoading />
                ) : KnowledgeCategory.length === 0 ? null : Intents.length === 0 ? (
                  <EmptyMessage message={"No Intents added for the selected Knowledge Category yet."} />
                ) : (
                  <>
                    <Table padding={"normal"}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Intent Name</TableCell>
                          <TableCell>Utterances</TableCell>
                          <TableCell>Responses</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentIntents.map(({ _id, intent, utterances, responses, knowledgeCategoryId, api }) => {
                          const hasApiDetails = api && Object.values(api).some(value => value);
                          return (
                            <TableRow key={_id} hover>
                              <TableCell style={{ fontWeight: 500 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  {intent}
                                  {hasApiDetails ? <Tooltip title="Has API"><ApiIcon color="primary" sx={{ fontSize: 18 }} /></Tooltip> : null}
                                </div>
                              </TableCell>
                              <TableCell style={{ maxWidth: '250px' }}>{utterances.join(', ')}</TableCell>
                              <TableCell style={{ maxWidth: '350px' }}>{responses.join(', ')}</TableCell>
                              <TableCell align="center">
                                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                  <Tooltip title="Edit" arrow>
                                    <IconButton size="small" color="primary" component={Link} to={{ pathname: routes.intentEdit.path(_id), state: { knowledgeCategoryId: this.state.activeCategoryId } }} disabled={!permissions.canEdit}><EditIcon style={{ fontSize: '20px' }} /></IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete" arrow>
                                    <IconButton size="small" color="error" onClick={() => this.handleDelete(_id, knowledgeCategoryId)} disabled={!permissions.canDelete}><DeleteIcon style={{ fontSize: '20px' }} /></IconButton>
                                  </Tooltip>
                                </div>
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                    {Intents.length > rowsPerPage && (
                      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <Pagination
                          count={Math.ceil(Intents.length / rowsPerPage)}
                          page={currentPage}
                          onChange={this.handlePageChange}
                          color="primary"
                        />
                      </div>
                    )}
                  </>
                )}
              </SectionPaper>
            </div>
          </div>
        )}
        {!isLoading && this.renderHelper()}
      </div>
    );
  }
}

List.propTypes = {
  classes: PropTypes.object.isRequired,
  messageShow: PropTypes.func.isRequired,
  getKnowledgeCategory: PropTypes.func.isRequired,
  getIntentsByKnowledgeCategory: PropTypes.func.isRequired,
  getIntents: PropTypes.func.isRequired,
  removeIntent: PropTypes.func.isRequired,
  trainIntents: PropTypes.func.isRequired,
  removeKnowledge: PropTypes.func.isRequired
};

export default connect(null, { messageShow, getKnowledgeCategory, getIntentsByKnowledgeCategory, getIntents, removeIntent, trainIntents, removeKnowledge })(withStyles(styles)(List));
